import { render } from "./TrainingsBlock.vue?vue&type=template&id=26569e0c&scoped=true"
import script from "./TrainingsBlock.vue?vue&type=script&lang=js"
export * from "./TrainingsBlock.vue?vue&type=script&lang=js"

import "./TrainingsBlock.vue?vue&type=style&index=0&id=26569e0c&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26569e0c"]])

export default __exports__